module.exports = __webpack_public_path__ + "media/images/favicons_staging/favicon-16x16-ab3638f9463823cf1962e8c3f0691b69.png";